var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseXRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#FFF1F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3091 10L15.4107 5.11094C15.4794 5.02969 15.4216 4.90625 15.3154 4.90625H14.0685C13.9951 4.90625 13.9248 4.93906 13.8763 4.99531L10.4935 9.02813L7.1107 4.99531C7.06382 4.93906 6.99351 4.90625 6.91851 4.90625H5.67163C5.56538 4.90625 5.50757 5.02969 5.57632 5.11094L9.67788 10L5.57632 14.8891C5.56092 14.9072 5.55104 14.9293 5.54785 14.9529C5.54467 14.9764 5.54831 15.0004 5.55834 15.022C5.56838 15.0435 5.58439 15.0617 5.60447 15.0745C5.62455 15.0872 5.64786 15.0939 5.67163 15.0938H6.91851C6.99195 15.0938 7.06226 15.0609 7.1107 15.0047L10.4935 10.9719L13.8763 15.0047C13.9232 15.0609 13.9935 15.0938 14.0685 15.0938H15.3154C15.4216 15.0938 15.4794 14.9703 15.4107 14.8891L11.3091 10Z",
    fill: "#FF7875"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseXRed);
export default __webpack_public_path__ + "static/media/close-x-red.a56a045b759f87461599edb2d9cb4b86.svg";
export { ForwardRef as ReactComponent };